import Vue from 'vue'
import Vuex from 'vuex'
import { sync } from 'vuex-router-sync'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import service from '@/utils/request'
import api from '@/utils/api'
import '@/assets/styles/new-module.css'
import FloatingBack from '@/components/FloatingBack.vue'
import Vant, { Search, Divider, Grid, GridItem, Overlay, Form, Field, Tabbar, TabbarItem } from 'vant'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import CloseDialogsPlugin from 'vux/src/plugins/close-dialogs/index.js'
import ConfigPlugin from 'vux/src/plugins/config/index.js'
import BusPlugin from 'vux/src/plugins/bus/index.js'
import DevicePlugin from 'vux/src/plugins/device/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


Vue.prototype.$ajax = service
Vue.prototype.$api = api

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.component('FloatingBack', FloatingBack)
Vue.use(Vant)
Vue.use(Divider)
Vue.use(Form)
Vue.use(Field)
Vue.use(Overlay)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Tabbar)
Vue.use(TabbarItem)

const store = new Vuex.Store({})
const shouldUseTransition = !/transition=none/.test(location.href)

Vue.use(CloseDialogsPlugin, router)
sync(store, router)

Vue.config.productionTip = false
Vue.config.devtools = true

store.registerModule('vux', {
state: {
demoScrollTop: 0,
isLoading: false,
direction: shouldUseTransition ? 'forward' : ''
},
mutations: {
updateDemoPosition (state, payload) {
state.demoScrollTop = payload.top
},
updateLoadingStatus (state, payload) {
state.isLoading = payload.isLoading
},
updateDirection (state, payload) {
if (!shouldUseTransition) {
return
}
state.direction = payload.direction
}
},
actions: {
updateDemoPosition ({ commit }, top) {
commit({ type: 'updateDemoPosition', top: top })
}
}
})

Vue.use(ConfigPlugin, { $layout: 'VIEW_BOX' })
Vue.use(DevicePlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(WechatPlugin)
Vue.use(AjaxPlugin)
Vue.use(BusPlugin)
Vue.use(DatetimePlugin)
Vue.use(Search)

const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
let isPush = false
let endTime = Date.now()
const routerMethods = ['push', 'go', 'replace', 'forward', 'back']

document.addEventListener('touchend', () => {
endTime = Date.now()
})

routerMethods.forEach(key => {
const method = router[key].bind(router)
router[key] = function (...args) {
isPush = true
method.apply(null, args)
}
})

router.beforeEach(function (to, from, next) {
store.commit('updateLoadingStatus', { isLoading: true })

const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)

if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.commit('updateDirection', { direction: 'forward' })
} else if (!isPush && (Date.now() - endTime) < 377) {
store.commit('updateDirection', { direction: '' })
} else {
store.commit('updateDirection', { direction: 'reverse' })
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('updateDirection', { direction: 'forward' })
}

if (/\/http/.test(to.path)) {
const url = to.path.split('http')[1]
window.location.href = `http${url}`
} else {
next()
}
})

router.afterEach(function () {
isPush = false
store.commit('updateLoadingStatus', { isLoading: false })
})

const vueThis = new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')

export default vueThis



// WEBPACK FOOTER //
// ./src/main.js